
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "Improving the White House Shutdown Clock";
export const description = "Redesigning and enhancing the White House’s official government shutdown clock.";
export const image = "/blog-images/clock.webp";
export const tags = ["Webdev", "Design", "Politics"];
function _createMdxContent(props) {
  const _components = {
    blockquote: "blockquote",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Note: This article is primarily an embedded frame. This may cause problems with assistive software."
      }), "\n"]
    }), "\n", _jsx("iframe", {
      src: "/blog/whitehouse-static.html",
      style: {
        border: 'none',
        width: '100%',
        height: '100%',
        minHeight: '500px'
      }
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	